"use client";

import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "type", "options", "orientation", "disabledOpacity", "disabledClass", "dataTestId", "renderOption"],
  _excluded2 = ["className", "type"];
var __jsx = React.createElement;
import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "@lib/cn";
import useCssModules from "@lib/hooks/use-css-modules";
const RadioGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      type,
      options = [],
      orientation = "vertical",
      disabledOpacity = 0.5,
      disabledClass,
      dataTestId,
      renderOption
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const baseId = React.useId();
  const {
    cssModules
  } = useCssModules();
  const {
    radioButtonLabelClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.radioGroup) || {};
  if (options.length > 0) {
    return __jsx(RadioGroupPrimitive.Root, _extends({
      className: cn(orientation === "horizontal" ? "flex flex-row gap-4" : "flex flex-col gap-2", className)
    }, props, {
      "data-testid": dataTestId,
      ref: ref
    }), options.map((option, index) => {
      const radioElement = __jsx(RadioGroupItem, {
        value: option.value,
        id: "".concat(baseId, "-").concat(index),
        disabled: props.disabled || option.disabled,
        "data-testid": dataTestId ? "".concat(dataTestId, "-").concat(index) : undefined
      });
      if (renderOption) {
        return __jsx("div", {
          key: option.value
        }, renderOption(option, index, radioElement));
      }
      return __jsx("div", {
        key: option.value,
        className: cn("flex items-center gap-1")
      }, radioElement, __jsx("label", {
        htmlFor: "".concat(baseId, "-").concat(index),
        className: cn("flex items-center cursor-pointer", radioButtonLabelClassName, (props.disabled || option.disabled) && disabledClass),
        style: {
          opacity: props.disabled || option.disabled ? disabledOpacity : 1
        }
      }, option.icon && __jsx("span", {
        className: "mr-2"
      }, option.icon), __jsx("span", {
        className: radioButtonLabelClassName
      }, option.label)));
    }));
  }
  return __jsx(RadioGroupPrimitive.Root, _extends({
    className: cn("grid gap-2", className)
  }, props, {
    ref: ref
  }));
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
      className,
      type
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
    cssModules
  } = useCssModules();
  const {
    radioButtonBaseClassName,
    radioButtonIndicatorClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.radioGroup) || {};
  return __jsx(RadioGroupPrimitive.Item, _extends({
    ref: ref,
    className: cn(radioButtonBaseClassName, className)
  }, props), __jsx(RadioGroupPrimitive.Indicator, {
    className: "flex items-center justify-center"
  }, __jsx("div", {
    className: radioButtonIndicatorClassName
  })));
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
export { RadioGroup, RadioGroupItem };